export default "__VITE_ASSET__7e8e331f__"